import { putData } from "../../../const/apiHelper";

export const updateUserApi = async (data) => {
  delete data.email;
  try {
    await putData(`/vendedores/${data.id}`, data);
  } catch (error) {
    console.error("Error al editar el usuario:", error);
  }
};
